
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet/dogs",
      function () {
        return require("private-next-pages/pet/dogs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet/dogs"])
      });
    }
  